import 'zone.js';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

/**
 * Extract federation slug from hostname at boot.
 * Supports multi-federation setup: frmtt.main.sportiq.ma
 * On localhost, uses environment.devFederationSlug for development.
 */
function extractFederationSlug(): string | null {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return (environment as any).devFederationSlug ?? null;
  }
  if (hostname.endsWith('.localhost')) {
    return hostname.slice(0, hostname.indexOf('.')).toLowerCase();
  }
  const baseDomain: string = (environment as any).baseDomain;
  if (!baseDomain) return null;
  if (hostname === baseDomain) return null;
  if (hostname.endsWith('.' + baseDomain)) {
    return hostname.slice(0, hostname.length - baseDomain.length - 1).toLowerCase();
  }
  return null;
}

export const FEDERATION_SLUG = extractFederationSlug();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
